<template lang="pug">
  a.panel.email(href="#" @click.prevent.stop="edit('email')")
    .icon
      svg.default-icon(
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      )
        path(
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.3"
          d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
        )
      edit-icon
    .data
      .label E-Mail Adresse
      .email-value
        nobr {{ email }}

    portal(to="modals")
      Modal(v-if="modal" @dismiss="dismiss" @close="close")
        validation-observer(v-slot="{ invalid }" ref="form")
          Spinner(v-if="loading" :size="16" :thickness="3")
          .p-4.bg-gray-200.rounded-t
            .alert.warning
              p Aus Sicherheitsgründen benötigen wir Ihr aktuelles Passwort, um die E-Mail Adresse zu ändern
            form.pt-6(@submit.prevent="submit")
              fieldset.form-field
                validation-provider(name="Aktuelles Passwort" rules="required" v-slot="{ errors }")
                  label.label(for="current-password") Aktuelles Passwort
                  .control.has-icons-right
                    input#current-password.input(
                      type="password"
                      name="current_password"
                      v-model="form.current_password"
                      :class="{ 'is-danger': errors && errors.length }"
                    )
                    span.icon
                      font-awesome-icon(icon="key")
                  p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                  p.help.has-text-grey(v-else) Pflichtfeld
              fieldset.form-field
                validation-provider(
                  name="Neue E-Mail Adresse"
                  :rules="`required|email|new-email:${member.email}|unique-email`"
                  v-slot="{ errors }"
                )
                  label.label(for="new-email") Neue E-Mail Adresse
                  .control.has-icons-right
                    input#new-email.input(
                      type="email"
                      name="email"
                      v-model="form.email"
                      :class="{ 'is-danger': errors && errors.length }"
                    )
                    span.icon
                      font-awesome-icon(icon="at")
                  p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                  p.help.has-text-grey(v-else) Pflichtfeld
              fieldset.form-field
                validation-provider(name="E-Mail Adresse wiederholen" rules="required|confirm:@Neue E-Mail Adresse" v-slot="{ errors }")
                  label.label(for="new-email") E-Mail Adresse wiederholen
                  .control.has-icons-right
                    input#new-email.input(
                      type="text"
                      name="email_confirm"
                      v-model="form.email_confirm"
                      :class="{ 'is-danger': errors && errors.length }"
                    )
                    span.icon
                      font-awesome-icon(icon="at")
                  p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                  p.help.has-text-grey(v-else) Pflichtfeld
          .bg-gray-100.p-4.rounded-b(class="md:flex md:flex-row-reverse md:justify-between")
            button.button(type="button" @click="submit" :disabled="invalid") Neue E-Mail speichern
            button.button.is-outlined(type="button" @click="close") Abbrechen
</template>

<script>
import Vue from 'vue';
import uniqid from 'uniqid';

import { mapGetters, mapActions } from 'vuex';
import { get } from '@/helpers';

import { VueReCaptcha } from 'vue-recaptcha-v3';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import EditIcon from '@/extensions/restricted-area/components/UserForm/Partials/EditIcon';
import Modal from '@/components/Modal';

export default {
    name: 'AccountEmail',
    data: () => ({
        modal: false,
        loading: false,
        form: {
            current_password: '',
            email: '',
            email_confirm: ''
        }
    }),
    components: {
        EditIcon,
        Modal,
        ValidationObserver,
        ValidationProvider
    },
    computed: {
        email() {
            return this.member.email || '--';
        },
        ...mapGetters({
            member: 'auth/member',
            recaptchaSiteKey: 'googleRecaptchaSiteKey'
        })
    },
    methods: {
        edit() {
            this.modal = true;
        },
        dismiss() {
            // if (this.form.current_password === '' && this.form.email === '') {
            //   this.close();
            // }
        },
        close() {
            this.modal = false;
            this.$nextTick(() => {
                this.form = {
                    current_password: '',
                    email: '',
                    email_confirm: ''
                };
            });
        },
        async submit() {
            this.loading = true;

            // TODO
            // 1. check the current password
            // 2. if succeed: submit member form with new email

            const valid = await this.$refs.form.validate();
            if (!valid) {
                const errorMessage = {
                    id: uniqid(),
                    title: 'Ungültiges Formular',
                    text: 'Korrigieren Sie Ihre Angaben.',
                    type: 'warning',
                    autoclose: 4000
                };
                this.addMessage(errorMessage);
            } else {
                let errorMessage = {
                    id: uniqid(),
                    title: 'Fehler',
                    text:
                        'Es gibt ein technisches Problem.<br>Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                    type: 'error',
                    autoclose: 8000
                };
                if (this.recaptchaSiteKey) {
                    await this.$recaptchaLoaded();
                    try {
                        await this.$recaptcha('auth');
                        // authenticate with the current password
                        // and the email from member state
                        const payload = {
                            email: this.member.email,
                            password: this.form.current_password,
                            skipRouterMapping: true
                        };
                        this.signin(payload)
                            .then(() => {
                                // submit the new email
                                // with the corrensponding id from member state
                                const payload = {
                                    id: parseInt(this.member.id),
                                    email: this.form.email
                                };
                                this.updateMember(payload)
                                    .then(() => {
                                        this.addMessage({
                                            id: uniqid(),
                                            title: 'Erfolg',
                                            text: 'Ihre E-Mail Adresse wurde erfolgreich geändert.',
                                            type: 'success',
                                            autoclose: 4000
                                        });
                                        this.close();
                                    })
                                    .catch(error => {
                                        console.error(error);
                                        this.addMessage(errorMessage);
                                    })
                                    .finally(() => {
                                        this.loading = false;
                                    });
                            })
                            .catch(error => {
                                const message = get(error, 'response.data.debugMessage');
                                if (message === 'email not verified') {
                                    errorMessage.text =
                                        'Ihre E-Mail wurde noch nicht verifiziert.<br>Bitte prüfen Sie Ihren Posteingang und bestätigen Sie Ihre E-Mail Adresse.';
                                    errorMessage.autoclose = false;
                                } else if (message === 'credentials invalid') {
                                    errorMessage.text = 'Das aktuelle Passwort ist nicht korrekt.';
                                    // errorMessage.autoclose = false;
                                    // this.form.current_password = '';
                                }
                                this.addMessage(errorMessage);
                                this.loading = false;
                            });
                    } catch (error) {
                        console.error(error);
                        this.loading = false;
                        this.addMessage(errorMessage);
                    }
                } else {
                    console.error('No ReCaptcha key!');
                    this.loading = false;
                    this.addMessage(errorMessage);
                }
            }
        },
        ...mapActions({
            addMessage: 'message/add',
            signin: 'auth/signin',
            updateMember: 'auth/updateMember'
        })
    },
    beforeMount() {
        if (this.recaptchaSiteKey) {
            Vue.use(VueReCaptcha, {
                siteKey: this.recaptchaSiteKey,
                loaderOptions: {
                    useRecaptchaNet: true
                }
            });
        }
    }
};
</script>

<style lang="sass" scoped>
.spinner-container
  position: absolute
  left: 0
  width: 100%
  top: 0
  height: 100%
  z-index: 1
  background: rgba(255, 255, 255, 0.5)
form
  fieldset.form-field:last-child
    @apply mb-0
</style>
